export default "__VITE_ASSET__d23fa32c__"